<div class="progress_bar_parent">
<p-progressBar mode="indeterminate" [style]="{'height': '8px','width':'50%','top':'50%','left':'30%','z-index':'20004'}"></p-progressBar>
</div>
